var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      [
        !_vm.isAndroid && !_vm.isIos
          ? _c("room-information", { staticClass: "va-card mb-6" })
          : _vm.isAndroid
          ? _c("room-information-android", { staticClass: "va-card mb-6" })
          : _c("room-information-ios", { staticClass: "va-card mb-6" }),
        _vm.isAndroid
          ? _c("remote-management-android", { staticClass: "mb-6" })
          : _vm._e(),
        _vm.isIos
          ? _c("remote-management-ios", { staticClass: "mb-6" })
          : _vm._e(),
        _vm.isAndroid
          ? _c("room-displays-android", { staticClass: "mb-6" })
          : _vm._e(),
        !_vm.isAndroid && !_vm.isIos
          ? _c("room-performance", { staticClass: "va-card mb-6" })
          : _vm._e(),
        !_vm.isAndroid && !_vm.isIos
          ? _c("performance-live", {
              staticClass: "va-card",
              attrs: { "room-id": _vm.roomId }
            })
          : _vm._e(),
        _vm.isAndroid ? _c("room-actions", { staticClass: "mt-6" }) : _vm._e()
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }